export const NONE = '0px';

export const SM = '2px';

export const BASE = '4px';

export const MD = '6px';

export const LG = '8px';

export const XL = '12px';

export const XXL = '16px';

export const XXXL = '24px';

export const FULL = '9999px';

const BasicRadius = {
    NONE,
    SM,
    BASE,
    MD,
    LG,
    XL,
    XXL,
    XXXL,
    FULL,
};

export default BasicRadius;
